import axios, { AxiosError, type AxiosInstance } from 'axios';
import { isApiEnvelope, getErrorFromApiEnvelope } from './api-envelope-utils';
import { getApiAccessToken } from './get-access-token';

const createHttpClient = (baseUrl: string): AxiosInstance => {
  const instance = axios.create({
    baseURL: baseUrl,
  });

  instance.interceptors.request.use(async (config) => {
    const token = await getApiAccessToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (config.responseType === 'blob') {
      config.headers.Accept = 'application/pdf';
    }

    return config;
  });

  instance.interceptors.response.use(
    (response) => {
      if (response.config.responseType === 'blob') {
        return response;
      }

      if (isApiEnvelope(response.data)) {
        response.data = response.data.content;
      } else {
        console.warn('API Envelope is missing from response');
      }

      return response;
    },
    (error) => {
      if (!(error instanceof Error)) return;
      if (error instanceof AxiosError && isApiEnvelope(error.response?.data)) {
        const apiEnvelopeErrorMessage = getErrorFromApiEnvelope(error.response.data);
        error.message = apiEnvelopeErrorMessage ?? error.message;
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

export default createHttpClient;
